import React from 'react'

const Footer = () => {
  return (
    <>

      <div className="container-fluid nav_bg">
        <div className="row">
          <div className='col-10 mx-auto'>
            <footer className='bg-light text-center mt-5 col-md'>
              <p>© 2022 Qrated. All rights reserved | Terms &  Conditions </p>
            </footer>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer